// extracted by mini-css-extract-plugin
export default {"labelContainer":"Label_labelContainer__h8rjs","bold":"Label_bold__WsO-V"};